// assets/notify-modal.js
// NOTE: We intentionally DO NOT AJAX-submit because Shopify CAPTCHA blocks /contact submissions
// without a valid hcaptcha token. We let the browser submit normally, then show success after
// redirect (?customer_posted=true).

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-notify-modal]');
  if (!modal) return;

  const dialog          = modal.querySelector('.notify-modal__dialog');
  const form            = modal.querySelector('#BackInStockForm');
  const firstNameInput  = modal.querySelector('#notify-first-name');
  const emailInput      = modal.querySelector('#notify-email');
  const tagsInput       = modal.querySelector('#notify-tags');

  const submitBtn       = modal.querySelector('[data-notify-submit]');
  const submitText      = modal.querySelector('[data-notify-submit-text]');
  const successEl       = modal.querySelector('[data-notify-success]');

  const TRANSITION_MS   = 220; // match your CSS transitions

  if (!form) {
    console.warn('[BackInStock] #BackInStockForm not found inside modal');
    return;
  }

  function slugify(str) {
    return (str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function lockScroll() {
    document.documentElement.classList.add('notify-modal-lock');
    document.body.classList.add('notify-modal-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('notify-modal-lock');
    document.body.classList.remove('notify-modal-lock');
  }

  // Strings live on the modal root as data-text-* so they stay translatable.
  function text(key, fallback) {
    return (modal && modal.dataset['text' + key.charAt(0).toUpperCase() + key.slice(1)]) || fallback;
  }

  function setLoading(isLoading) {
    if (!submitBtn) return;
    submitBtn.disabled = isLoading;
    submitBtn.classList.toggle('is-loading', isLoading);
    if (submitText) submitText.textContent = isLoading ? text('submitting', 'Submitting…') : text('submit', 'Submit');
  }

function showSuccess() {
  // Hide form + supporting copy
  form.classList.add('hidden');

  const subtitle = modal.querySelector('[data-notify-subtitle]');
  if (subtitle) subtitle.classList.add('hidden');

  // Optionally adjust title (optional but nice)
  const title = modal.querySelector('.notify-modal__title');
  if (title) title.textContent = text('successTitle', 'Thanks!');

  // Show success message
  if (successEl) successEl.classList.remove('hidden');

  setLoading(false);
}


  function resetUI() {
    setLoading(false);
    if (successEl) successEl.classList.add('hidden');
    form.classList.remove('hidden');
    // Don't reset values on success-open; do reset on close
    form.reset();
  }

  function openModal({ focus = true } = {}) {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      if (!focus) return;

      setTimeout(() => {
        if (firstNameInput) firstNameInput.focus();
        else if (emailInput) emailInput.focus();
      }, 150);
    });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    setTimeout(() => {
      modal.classList.add('hidden');
      unlockScroll();
      resetUI();
    }, TRANSITION_MS);
  }

  // ---------- OPEN: clicking your Notify button(s) ----------
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-notify-open]');
    if (!btn) return;

    event.preventDefault();

    const productTitle = btn.getAttribute('data-notify-product-title') || '';
    const variantTitle = btn.getAttribute('data-notify-variant-title') || '';

    if (tagsInput) {
      const productSlug = slugify(productTitle);
      const variantSlug = slugify(variantTitle);
      const dynamicTag  = `back-in-stock-request-${productSlug}-${variantSlug}`;
      tagsInput.value = `back-in-stock-request,${dynamicTag}`;
    }

    openModal({ focus: true });
  });

  // ---------- CLOSE: click outside dialog (overlay/backdrop) ----------
  modal.addEventListener('click', function (event) {
    if (dialog && dialog.contains(event.target)) return; // inside click = ignore
    closeModal();
  });

  // ---------- CLOSE: explicit close buttons ----------
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-notify-close]')) return;
    event.preventDefault();
    closeModal();
  });

  // ---------- CLOSE: Escape ----------
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });

  // ---------- SUBMIT: normal submit (CAPTCHA-compatible) ----------
  // Do NOT preventDefault. Just set loading state; Shopify will handle CAPTCHA and redirect.
  form.addEventListener('submit', function () {
    setLoading(true);
  });

  // ---------- SUCCESS AFTER REDIRECT ----------
  // Shopify adds ?customer_posted=true when customer/newsletter form submission succeeds.
  (function showSuccessAfterRedirect() {
    const params = new URLSearchParams(window.location.search);
    const posted = params.get('customer_posted') === 'true';
    if (!posted) return;

    // Open modal without focusing inputs
    openModal({ focus: false });

    // Show success state
    showSuccess();

    // Optional: auto-close after a moment
    setTimeout(() => closeModal(), 7800);

    // Clean URL so refresh doesn't re-trigger success
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      // preserve any other params
      history.replaceState({}, '', url.toString());
    } catch (e) {
      // ignore
    }
  })();
});
